<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cNmLL4/tc-custom/9781426898969.jpg?1728726486302" alt="This image is the cover for the book Her Holiday Man"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Her Holiday Man
      </h1>
      <p class="bookDescription body article font2">
        <b>A single mother and a handsome widower find love and healing when the holiday season brings them together in this romance from a <i>New York Times </i>bestseller.</b><br/><br/>Christina Forrester is starting over. After a financial scandal sent her ex-husband to prison, she’s left raising her young son without any of the comforts of their old life. Budgets, coupons, lawn care—you name it, she’s learning to do it all on her own. Well, almost on her own—she’d be lost without Gail Broughton, the kind widow across the street. But when Gail’s son comes home, Christina’s vow to never trust a man again is put to the test.<br/><br/>Will Broughton left town because he was tired of being “that poor man” who lost his wife and unborn child in a tragic accident. But years have passed and, with his dad gone and his mom alone, it’s time to go home. Only his mother’s not alone. She’s taken Christina under her wing, and the beautiful and determined single mother awakens something in Will he thought was buried forever.<br/><br/>As Will and Christina are forced to spend more time together, feelings that are more than neighborly grow between them. And with Christmas coming and a child filling both houses with holiday cheer, it becomes nearly impossible not to embrace the joy—and the love—in their lives.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shannon Stacey
      </h2>
      
      <p class="authorDescription body article"><I>New York Times&#160;</I>and <I>USA Today</I> bestselling author Shannon Stacey lives with her husband and two sons in New England, where her two favorite activities are writing stories of happily ever after and off-roading with her friends and family. You can contact Shannon through her website, www.shannonstacey.com, as well as sign up for her newsletter.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c9340adc